import {Rect} from '@legit-health/ui';
import Konva from 'konva';

export default function calculateRect(group: Konva.Group, scaleFactor: number): Rect {
  const scaleX = group.scaleX();
  const scaleY = group.scaleY();
  group.scaleX(1);
  group.scaleY(1);

  const position = group.position();

  return {
    topLeft: {
      x: position.x / scaleFactor,
      y: position.y / scaleFactor
    },
    width: Math.max(5, (group.width() * scaleX) / scaleFactor),
    height: Math.max(5, (group.height() * scaleY) / scaleFactor)
  };
}
